import { createBillHeadInfo } from './create';
import { setBillHeadInfoVisible } from './methods';

export default {
    createBillHeadInfo,
    setBillHeadInfoVisible,
}